import ReportModalItem from './report-modal-item'

export default ReportModalItem
